module.exports = __webpack_public_path__ + "static/CSUF-College-Education-Grant-Schools-First-800x500-9d3da7915c4bf953a4ca3f4085d42b4d.jpg";